export default "__VITE_ASSET__0161e431__"